var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "table-top" },
        [
          !_vm.disabled
            ? _c("el-button", { on: { click: _vm.addRow } }, [
                _vm._v("添加一行"),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "vxe-table",
        {
          attrs: {
            border: "",
            align: "center",
            size: "mini",
            data: _vm.tableData,
            "edit-config": { trigger: "click", mode: "row" },
          },
        },
        [
          _c("vxe-column", {
            attrs: { align: "center", title: "序号", type: "seq", width: "60" },
          }),
          _vm.type === "1"
            ? _c("vxe-column", {
                attrs: { field: "productCode", title: "跳转产品" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                filterable: "",
                                placeholder: "请选择",
                                clearable: "",
                              },
                              on: { change: (e) => _vm.prodectChange(row, e) },
                              model: {
                                value: row.productCode,
                                callback: function ($$v) {
                                  _vm.$set(row, "productCode", $$v)
                                },
                                expression: "row.productCode",
                              },
                            },
                            _vm._l(_vm.options, function (item) {
                              return _c("el-option", {
                                key: item.productCode,
                                attrs: {
                                  label: item.productName,
                                  value: item.productCode,
                                },
                              })
                            }),
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2786919550
                ),
              })
            : _vm._e(),
          _vm.type === "3"
            ? _c("vxe-column", {
                attrs: { field: "jumpType", title: "跳转页面" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                filterable: "",
                                placeholder: "请选择",
                                clearable: "",
                              },
                              on: { change: _vm.changeEvent },
                              model: {
                                value: row.jumpType,
                                callback: function ($$v) {
                                  _vm.$set(row, "jumpType", $$v)
                                },
                                expression: "row.jumpType",
                              },
                            },
                            _vm._l(_vm.options, function (item) {
                              return _c("el-option", {
                                key: item.dictCode,
                                attrs: {
                                  label: item.dictValue,
                                  value: item.dictCode,
                                },
                              })
                            }),
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1484949613
                ),
              })
            : _vm._e(),
          _c("vxe-column", {
            attrs: { field: "url", title: "上传图片" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "div",
                      [
                        _c("UploadImage", {
                          attrs: { value: row.url, disabled: _vm.disabled },
                          on: {
                            change: (files) => _vm.changeFiles(files, row),
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          !_vm.disabled
            ? _c("vxe-column", {
                attrs: { title: "操作", "show-overflow": "", width: "80" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("el-button", {
                            attrs: {
                              type: "danger",
                              icon: "el-icon-delete",
                              circle: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.removeEvent(row)
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2269260287
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }